import Analytics from "analytics/util/Analytics";
import sourceFromPathname from "analytics/util/source";
import { isDesktop } from "shared/util/EnvironmentHelpers";

function analyticsAttrs(totalLikesReceived) {
	return {
		"promo driver": "in app regret swipe",
		mechanism: "notification",
		"total likes received": totalLikesReceived,
	};
}

export function passedOnPotentialMatchEvent(totalLikesReceived) {
	Analytics.logUIEvent(Analytics.eventNames.passedOnPotentialMatch, {
		data: {
			platform: isDesktop ? "desktop" : "mobile web",
			source: sourceFromPathname(),
			"total likes received": totalLikesReceived,
		},
	});
}

export function viewedPromoDriverEvent(likesCount) {
	Analytics.logUIEvent(Analytics.eventNames.viewedPromoDriver, {
		data: {
			...analyticsAttrs(likesCount),
		},
	});
}

export function selectedPromoDriverEvent(likesCount) {
	Analytics.logUIEvent(Analytics.eventNames.selectedPromoDriver, {
		data: {
			...analyticsAttrs(likesCount),
		},
	});
}

export function dismissedPromoDriverEvent(likesCount) {
	Analytics.logUIEvent(Analytics.eventNames.dismissedPromoDriver, {
		data: {
			...analyticsAttrs(likesCount),
		},
	});
}




// WEBPACK FOOTER //
// ./src/shared/components/RegretSwipeAlert/analytics.js